<script type="text/javascript" language="javascript">
    var versionUpdate = (new Date()).getTime();
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "/user-list.component.js?v=" + versionUpdate;
    document.body.appendChild(script);
</script>

<script type="text/javascript" src="user-list.component.js?v=1"></script>

<div class="component-content paged heightcls" style="overflow:auto;">
    <table class="table m-table table-bordered table-hover table-heading">
        <colgroup>
            <col style="width: 10%" />
            <col style="width: 10%" />
            <col style="width: 12%" />
            <col style="width: 10%" />
            <col style="width: 12%" />
            <col style="width: 11%" />
            <col style="width: 11%" />
            <col style="width: 10%" />
            <col style="width: 15%" />
        </colgroup>
        <thead>
            <tr>
                <th>
                    <span>First Name</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('FirstName')" [class.btn-warning]="isSort('FirstName')" [class.btn-default]="!isSort('FirstName')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('FirstName')" [class.fa-sort-alpha-desc]="isSortDesc('FirstName')"></i>
                    </button>
                </th>
                <th>
                    <span>Last Name</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('LastName')" [class.btn-warning]="isSort('LastName')" [class.btn-default]="!isSort('LastName')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('LastName')" [class.fa-sort-alpha-desc]="isSortDesc('LastName')"></i>
                    </button>
                </th>
                <th>
                    <span>Username</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('UserName')" [class.btn-warning]="isSort('UserName')" [class.btn-default]="!isSort('UserName')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('UserName')" [class.fa-sort-alpha-desc]="isSortDesc('UserName')"></i>
                    </button>
                </th>
                <th>
                    <span>Permission Level</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('Permission')" [class.btn-warning]="isSort('Permission')" [class.btn-default]="!isSort('Permission')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('Permission')" [class.fa-sort-alpha-desc]="isSortDesc('Permission')"></i>
                    </button>
                </th>
                <th>
                    <span>Created By</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('CreatedBy')" [class.btn-warning]="isSort('CreatedBy')" [class.btn-default]="!isSort('CreatedBy')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('CreatedBy')" [class.fa-sort-alpha-desc]="isSortDesc('CreatedBy')"></i>
                    </button>
                </th>
                <th>
                    <span>Company</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('Company')" [class.btn-warning]="isSort('Company')" [class.btn-default]="!isSort('Company')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('Company')" [class.fa-sort-alpha-desc]="isSortDesc('Company')"></i>
                    </button>
                </th>
                <th>
                    <span>Minesite</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('Minesite')" [class.btn-warning]="isSort('Minesite')" [class.btn-default]="!isSort('Minesite')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('Minesite')" [class.fa-sort-alpha-desc]="isSortDesc('Minesite')"></i>
                    </button>
                </th>
                <th>
                    <span>Last Login</span>
                    <button class="btn btn-xs pull-right" (click)="sortBy('LastLogin')" [class.btn-warning]="isSort('LastLogin')" [class.btn-default]="!isSort('LastLogin')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="!isSortDesc('LastLogin')" [class.fa-sort-alpha-desc]="isSortDesc('LastLogin')"></i>
                    </button>
                </th>
                <th>
                    <div class="btn-toolbar">
                        <div class="btn-group btn-group-md">
                            <a class="btn btn-primary" (click)="addUser()" title="Add User">
                                <i class="fa fa-fw fa-plus"></i> Add User
                            </a>
                            <div class="btn-group btn-group-md">
                                <user-filter></user-filter>
                            </div>
                        </div>
                    </div>
                </th>
            </tr>
        </thead>
    </table>

    <table class="table m-table table-bordered table-hover" style="height:95%; display:block;">
        <colgroup>
            <col style="width: 10%" />
            <col style="width: 10%" />
            <col style="width: 12%" />
            <col style="width: 10%" />
            <col style="width: 12%" />
            <col style="width: 11%" />
            <col style="width: 10%" />
            <col style="width: 11%" />
            <col style="width: 15%" />
        </colgroup>

            <tr *ngIf="processing">
                <td colspan="9" style="align-content:center">
                    <div style="text-align:center;">
                        <h3>Loading Users...</h3>
                        <i class="fa fa-spinner fa-spin fa-pulse fa-5x"></i>
                    </div>
                </td>
            </tr>
            <tr *ngFor="let user of users.Data">
                <td class="table-bordered" style="padding: 4px; word-break: break-word;">
                        <!--<div class="pull-left" data-bind="visible: $data.UserName () !== $parents[2].userName()">
            <span class="fa fa-asterisk" data-bind="visible: $data.Id() <= -1"></span>
            <div data-bind="with: $data.state()">
                <span class="fa fa-wrench" data-bind="visible: name != 'Unchanged' && name != 'Added' && name != 'Deleted'"></span>
                <span class="fa fa-trash-o" data-bind="visible: name == 'Deleted'"></span>
            </div>
        </div>-->
                        <div>{{ user.FirstName }}</div>
                </td>
                <td class="table-bordered" style="padding: 4px;">
                    <div>{{ user.LastName }}</div>
                </td>
                <td class="table-bordered" style="padding: 4px; word-break: break-word;">
                    <div>{{ user.UserName }}</div>
                </td>
                <td class="table-bordered" style="padding: 4px;">
                    <div class="form-control-static">{{ user.Permission.Name }} {{ user.Companies.length > 0 ? '*' : '' }}</div>
                </td>
                <td class="table-bordered" style="padding: 4px; word-break: break-word;">
                    <div class="form-control-static">{{ user.CreatedBy }} </div>
                </td>
                <td class="table-bordered" style="padding: 4px;">
                    <div class="form-control-static">{{ user.Company?.Name }}</div>
                </td>
                <td class="table-bordered" style="padding: 4px;">
                    <div class="form-control-static">{{ user.Minesite?.Name }}</div>
                </td>
                <td class="table-bordered" data-bind="with:$data.LastLogin" style="padding: 4px;">
                    <div *ngIf="user.LastLogin" class="form-control-static">{{ user.LastLogin | amDateFormat: 'MM/DD/YYYY' }} at {{ user.LastLogin | amDateFormat: 'hh:mm A' }}</div>
                </td>
                <td class="table-bordered" style="padding: 4px;">
                    <div class="btn-group btn-group-justified" style="padding: 4px; ">
                        <a class="btn btn-primary btn-sm" title="Lock/Unlock User" [class.disabled]="disable" (click)="toggle(user)">
                            <i *ngIf="!user.Active" class="fa fa-fw fa-lock" data-toggle="tooltip"></i>
                            <i *ngIf="user.Active" class="fa fa-fw fa-unlock" data-toggle="tooltip"></i>
                        </a>
                        <a class="btn btn-primary btn-sm" title="User Details / Edit" [class.disabled]="disable" (click)="edit(user)">
                            <i class="fa fa-list-alt fa-fw" data-toggle="tooltip"></i>
                        </a>
                        <a class="btn btn-primary btn-sm" title="Delete User" [class.disabled]="disable" (click)="remove(user)">
                            <i class="fa fa-trash-o fa-fw" data-toggle="tooltip"></i>
                        </a>
                    </div>
                </td>
            </tr>
    </table>
</div>

<div bsModal #userEditModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" data-bind="showModal: modalActive, onShow: modalControl, onHide: modalControl">
	<div class="modal-dialog" style="width: 60%;">
		<div class="modal-content" data-bind="with: entity">
			<form #userform="ngForm" (ngSubmit)="validateFormDetails()">
				<div class="modal-header">
					<button type="button" class="close" aria-hidden="true" (click)="cancel()">&times;</button>
					<h4 class="modal-title" id="myModalLabel">
						<span>{{ user.Id === 0 ? 'Create User' : 'User Details &bull; ' + user.UserName }}</span>
					</h4>
				</div>
				<div class="modal-body" data-bind="with: $data.entity">
					<ul class="nav nav-tabs nav-justified" *ngIf="((user.PermissionId == 2) ||(user.PermissionId == 5)) && user.Id > 0">
						<li role="presentation" [class.active]="assignCompanies !== true">
							<a role="tab" (click)="assignCompanies = false">User Information</a>
						</li>
						<li role="presentation" [class.active]="assignCompanies === true">
							<a (click)="assignCompanies = true" role="tab">Company Assignments</a>
						</li>
					</ul>
					<div class="tab-content">
                        <div id="userInfo" class="tab-pane" [class.in]="assignCompanies === false" [class.active]="assignCompanies === false">
                            <div class="row">
                                <div class="col-lg-12 center-block" [class.col-lg-12]="user.Id === 0" [class.center-block]="user.Id === 0" [class.col-lg-6]="user.Id > 0">
                                    <div>Account Settings</div>
                                </div>
                                <div class="col-lg-6" *ngIf="user.Id > 0">
                                    <span class="pull-right"  style="padding-right:15px;">
                                        Created By <i class="fa fa-ellipsis-v"></i>
                                        <span> {{user.CreatedBy}}</span>
                                    </span>
                                    <span class="pull-right" style="padding-right:15px;">
                                        <span>Added </span>
                                        <i class="fa fa-ellipsis-v"></i>
                                        <span> {{ user.RegistrationDate | amDateFormat: 'MM/DD/YYYY' }} at {{ user.RegistrationDate | amDateFormat: 'hh:mm A' }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group input-group has-feedback" [class.has-error]="FirstName.touched  && FirstName.invalid">
                                        <label class="control-group input-group-addon" for="FirstName">First Name</label>
                                        <input id="FirstName" name="FirstName" type="text" class="form-control" placeholder="First Name" [(ngModel)]="user.FirstName" required #FirstName="ngModel"/>
                                        
                                    </div>
                                    <div *ngIf="FirstName.touched && FirstName.invalid"><label class="text-danger" >First Name is required</label></div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group input-group has-feedback" data-bind="validationElement: LastName" [class.has-error]="LastName.touched  && LastName.invalid">
                                        <label class="control-group input-group-addon" for="LastName">Last Name</label>
                                        <input id="LastName" name="LastName" type="text" class="form-control" placeholder="Last Name" [(ngModel)]="user.LastName" required #LastName="ngModel" />
                                    </div>
                                    <div *ngIf="LastName.touched && LastName.invalid"><label class="text-danger">Last Name is required</label></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group input-group has-feedback" data-bind="validationElement: UserName" [class.has-error]="UserName.touched  && UserName.invalid">
                                        <label class="control-label input-group-addon" for="UserName">Username</label>
                                        <input id="UserName" name="UserName" type="text" class="form-control" placeholder="Username" [(ngModel)]="user.UserName" disabled="{{ user.Id > 0 }}" required #UserName="ngModel"/>
                                    </div>
                                     <div *ngIf="UserName.touched && UserName.invalid"><label class="text-danger">User Name is required</label></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="checkbox">
                                        <label><input id="AllowPrinting" name="AllowPrinting" type="checkbox" [checked]="user.AllowPrinting" (change)="PrintCBChanged()">Print</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="user.Id > 0">
                                <div class="col-lg-12">
                                    <button type="button" class="btn btn-block btn-danger" (click)="resetPassword()">Reset Password</button>
                                </div>
                            </div>
                            <div class="row" *ngIf="user.Id > 0" style="padding-top: 8px;">
                                <div class="col-lg-12">
                                    <button type="button" class="btn btn-block btn-danger" (click)="resetPasswordandQuestions()">Reset Password and Security Questions</button>
                                </div>
                            </div>
                            <hr />
                            <div class="row">
                                <div class="col-lg-12">
                                    <span class="center-block">ProManual Settings</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group input-group" [class.has-error]="Permission.touched  && Permission.invalid">
                                        <label class="control-label input-group-addon">Permission</label>
                                        <select id="permissionId" name="permissionId" [(ngModel)]="user.PermissionId" (ngModelChange)="setUserCompany($event)" required="required" class="form-control" #Permission="ngModel">
                                            <option value="" [selected]="user.PermissionId === null">-- Select Permission --</option>
                                            <option *ngFor="let permission of permissions" [value]="permission.Id" [selected]="user.PermissionId == permission.Id">{{ permission.Name }}</option>
                                        </select>
                                    </div>
                                    <div *ngIf="Permission.touched && Permission.invalid"><label class="text-danger">Please select at least one Permisssion</label></div>
                                </div>
                            </div>

                            <div class="row" *ngIf="user.PermissionId == 1">
                                <div class="col-lg-12">
                                    <span class="center-block">Administrative Permissions</span>
                                    <div class="row">
                                        <div class="col-lg-3" *ngFor="let section of sectionPermissions.Data">
                                            <div class="checkbox">
                                                <label>
                                                    <input type="checkbox" name="{{section.Name}}" [(ngModel)]="section.Allowed" (checked)="section.Allowed" /> <span>{{ section.Name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="user.PermissionId >= 3 && user.PermissionId <= 4">
                                <div class="col-lg-12">
                                    <div class="form-group input-group has-feedback">
                                        <label class="control-label input-group-addon" for="CompanyId">Company</label>
                                        <select id="CompanyId" name="CompanyId" [(ngModel)]="user.CompanyId" class="form-control" (ngModelChange)="setUserCompany()" required="required">
                                            <option value="null" [selected]="user.CompanyId === null">-- Select Company --</option>
                                            <option *ngFor="let company of companies" [ngValue]="company.Id" [selected]="user.CompanyId == company.Id">{{ company.Name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <label class="text-danger" *ngIf="companyError" >Please select a Company</label>
                                </div>
                            </div>
                            <div class="row" *ngIf="user.CompanyId && user.PermissionId == 4 && user.Company.Minesites">
                                <div class="col-lg-12">
                                    <div class="form-group input-group has-feedback">
                                        <label class="control-label input-group-addon" for="MinesiteId">Mine Site</label>
                                        <select id="MinesiteId" name="MinesiteId" [(ngModel)]="user.MinesiteId" class="form-control" (ngModelChange)="setUserMinesite($event)" required="required">
                                            <option value="null" [selected]="user.MinesiteId === null">-- Select Minesite --</option>
                                            <option *ngFor="let minesite of user.Company.Minesites.Data" [ngValue]="minesite.Id" [selected]="user.MinesiteId == minesite.Id">{{ minesite.Name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <label class="text-danger" *ngIf="minesiteError">Please select a Minesite</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group input-group has-feedback" [class.has-error]="Language.touched  && Language.invalid">
                                        <label class="control-label input-group-addon">Language</label>
                                        <select id="LanguageName" name="LanguageName" [(ngModel)]="user.LanguageName" required="required" class="form-control" #Language="ngModel">
                                            <option value="" [selected]="user.LanguageName === null">-- Select Language --</option>
                                            <option *ngFor="let language of languages" [value]="language.Part" [selected]="user.LanguageName == language.Part">{{ language.Value }}</option>
                                        </select>
                                    </div>
                                    <div *ngIf="Language.touched && Language.invalid"><label class="text-danger">Please select atleast one Language</label></div>
                                </div>
                            </div>
                        </div>
						<div id="companyAssignment" class="tab-pane"  [class.in]="assignCompanies === true" [class.active]="assignCompanies === true" *ngIf="((user.PermissionId == 2) || (user.PermissionId == 5)) && user.Id > 0">
							<div class="row">
								<div class="col-md-6">
									<div class="panel panel-success" style="margin-bottom:0;">
										<div class="panel-heading">
											<h5 style="display: inline-block">
												<span class="badge">{{ user.Companies.length !== 0 ? user.Companies.length : companies.length }}</span>
												<span>Assigned</span>
											</h5>
											<div class="pull-right btn-group btn-group-md">
												<a class="btn btn-info" title="Remove Selected" (click)="removeSelected()">
													<span data-toggle="tooltip" class="fa fa-minus"></span>
												</a>
												<a class="btn btn-info" title="Select All" (click)="selectAllAssociated()">
													<span data-toggle="tooltip" class="fa fa-check-square-o"></span>
												</a>
											</div>
										</div>
										<div class="panel-body">
											<div class="list-group" style="overflow-y:scroll; height: 400px;">
												<div class="list-group-item" style="padding: 0;" *ngFor="let company of (companyList(true) | orderBy: 'Name')">
													<div class="panel-group" *ngIf="isCompanyAssigned(company.Id)">
														<div class="panel" [class.panel-success]="isAssociatedSelected(company.Id)" (click)="selectAssociated(company.Id)">
															<div class="panel-heading" style="padding: 0 0 0 5px;">
																<h5 style="display: inline-block">
																	{{ company.Name }}
																</h5>
																<div class="clearfix"></div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="panel panel-success" style="margin-bottom:0;">
										<div class="panel-heading">
											<h5 style="display: inline-block">
												<span class="badge">{{ user.Companies.length !== 0 ? companies.length - user.Companies.length : 0 }}</span>
												<span>Unassigned</span>
											</h5>
											<div class="pull-right btn-group btn-group-md">
												<a class="btn btn-info" title="Assign Selected" (click)="associateSelected()">
													<span data-toggle="tooltip" class="fa fa-plus"></span>
												</a>
												<a class="btn btn-info" title="Select All" (click)="selectAllCompanies()">
													<span data-toggle="tooltip" class="fa fa-check-square-o"></span>
												</a>
											</div>
										</div>
										<div class="panel-body">
											<div class="list-group" style="overflow-y:scroll; height: 400px;">
												<div class="list-group-item" style="padding: 0;" *ngFor="let company of (companyList(false) | orderBy: 'Name')">
													<div class="panel-group" *ngIf="!isCompanyAssigned(company.Id)">
														<div class="panel" [class.panel-success]="isCompanySelected(company.Id)" (click)="selectFromAll(company.Id)">
															<div class="panel-heading" style="padding: 0 0 0 5px;">
																<h5 style="display: inline-block">
																	{{ company.Name }}
																</h5>
																<div class="clearfix"></div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<hr />
							<div class="row">
								<div class="col-lg-12">
									<span><b>NOTE:</b> The user must have at least one company assignment.</span>
								</div>
							</div>
						</div>
					</div>
				</div>
                <div class="modal-footer">
                    <button *ngIf="((user.PermissionId == 2) ||(user.PermissionId == 5)) && user.Id == 0" type="button" class="btn btn-info" (click)="saveAndAssign()" [disabled]="userform.invalid">Save & Assign Companies</button>
                    <button type="button" class="btn btn-default" (mousedown)="cancel()">Close</button>
                    <button *ngIf="user.Id > 0" type="button" class="btn btn-info" (click)="showChangeUserNameModal()">Change Username</button>
                    <button type="submit" [disabled]="userform.invalid" class="btn btn-info">Save</button>
                </div>
			</form>
		</div>
	</div>
</div>

<div style="z-index: 1070;" *ngIf="user.Id > 0" bsModal #usernameEditModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" data-bind="showModal: modalActive, onShow: modalControl, onHide: modalControl">
    <div class="modal-dialog" style="width: 60%;">
        <div class="modal-content" data-bind="with: entity">
            <form #userform="ngForm" (ngSubmit)="updateUsername()">
                <div class="modal-header">
                    <button type="button" class="close" aria-hidden="true" (click)="cancelUserNameModal()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">
                        <span>{{ 'Change Username &bull; ' + user.UserName }}</span>
                    </h4>
                </div>
                <div class="modal-body" data-bind="with: $data.entity">

                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group input-group">
                                <label class="control-label input-group-addon" for="OldUserName">Old Username</label>
                                <input id="OldUserName" name="OldUserName" type="text" class="form-control" [(ngModel)]="user.UserName" disabled="disabled" #UserName="ngModel" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group input-group">
                                <label class="control-label input-group-addon" for="NewUserName">New Username</label>
                                <input id="NewUserName" name="NewUserName" type="text" class="form-control" placeholder="NewUserName" [(ngModel)]="newUsername" required #UserName="ngModel" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" (mousedown)="cancelUserNameModal()">Close</button>
                    <button type="submit" [disabled]="userform.invalid" class="btn btn-info">Save</button>
                </div>
            </form>
        </div>
    </div>
</div>